import { Link } from "react-router-dom";
import PaymentMethods from "@/components/marketplace/PaymentMethods";
import { useEffect, useState } from "react";
import { fetchBranding } from "@/lib/api";

/**
 * Marketplace footer — dark navy, 5-column grid on desktop.
 * Used across all public-facing pages.
 */
export default function SiteFooter() {
  const [brand, setBrand] = useState({ brand_name: "CasperDomains" });
  useEffect(() => { fetchBranding().then(setBrand).catch(() => {}); }, []);
  const year = new Date().getFullYear();

  return (
    <footer className="cd-footer" data-testid="site-footer">
      <div className="cd-container">
        <div className="cd-footer__grid">
          <div>
            <Link to="/" className="cd-brand" style={{ color: "#fff" }}>
              <span className="cd-brand__symbol" />
              <span>Casper<span className="cd-brand__second">Domains</span></span>
            </Link>
            <p style={{ marginTop: 18, maxWidth: 320, fontSize: 13, color: "rgba(255,255,255,.68)", lineHeight: 1.6 }}>
              A curated brokerage for premium expired domains. One desk,
              hand-picked inventory, priced to move.
            </p>
          </div>
          <div>
            <h4>Marketplace</h4>
            <Link to="/#featured">Featured domains</Link>
            <Link to="/#categories">Categories</Link>
            <Link to="/#sellers">Sell with us</Link>
            <Link to="/about">The story</Link>
          </div>
          <div>
            <h4>Buyers</h4>
            <Link to="/#buy-now">Buy now</Link>
            <Link to="/#make-offer">Make an offer</Link>
            <Link to="/#lease">Lease to own</Link>
            <a href="mailto:hello@casperdomains.com">Contact broker</a>
          </div>
          <div>
            <h4>Trust</h4>
            <a href="https://escrow.com" target="_blank" rel="noreferrer">Escrow.com</a>
            <a href="https://stripe.com" target="_blank" rel="noreferrer">Stripe</a>
            <a href="https://spaceship.com" target="_blank" rel="noreferrer">Spaceship</a>
            <a href="mailto:privacy@casperdomains.com">Privacy</a>
          </div>
          <div>
            <h4>Company</h4>
            <a href="mailto:hello@casperdomains.com">hello@casperdomains.com</a>
            <Link to="/about">About</Link>
            <Link to="/login" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
        <div className="cd-footer__bottom" style={{ flexDirection: "column", alignItems: "flex-start", gap: 16 }}>
          <PaymentMethods tone="dark" note={false} />
          <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "space-between", width: "100%" }}>
            <span>© {year} {brand.brand_name}. All rights reserved.</span>
            <span style={{ color: "rgba(255,255,255,.5)" }}>Built for founders in a hurry.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
